import * as React from "react";

import {
  AnalyticsConfigurationProvider,
  AnalyticsProvider,
  createAnalyticsContext,
  useAnalyticsOtpGtm,
} from "../../../Common";

import { useReactPdpInitialState } from "../react-pdp-initial-state-provider";

import { ReactPdpAnalyticsInterface } from "./analytics-interface";
import { useAnalyticsXO } from "./analytics-xo";
import { useAnalyticsGtm } from "./analytics-gtm";
// M2-2047: the Triple Whale upsell ("Customers Also Purchased") recommendation tracking is
// parked — recommendation widgets are out of the phase-1 scope. The implementation
// (./analytics-triplewhale) stays; re-enable it by restoring this import and its list entry.
// import { useAnalyticsTripleWhale } from "./analytics-triplewhale";

export const [analyticsContext, usePdpAnalytics] =
  createAnalyticsContext<ReactPdpAnalyticsInterface>();

const PdpAnalyticsProvider_Implementations: React.FunctionComponent = (
  props
) => {
  const analyticsXO = useAnalyticsXO();
  const analyticsGtm = useAnalyticsGtm();
  const analyticsOtpGtm = useAnalyticsOtpGtm<ReactPdpAnalyticsInterface>();
  // M2-2047: parked, see the import above.
  // const analyticsTripleWhale = useAnalyticsTripleWhale();

  const implementations = React.useMemo(
    () => [analyticsXO, analyticsGtm, analyticsOtpGtm],
    [analyticsXO, analyticsGtm, analyticsOtpGtm]
  );

  return (
    <AnalyticsProvider
      context={analyticsContext}
      implementations={implementations}
    >
      {props?.children || []}
    </AnalyticsProvider>
  );
};

export const PdpAnalyticsProvider: React.FunctionComponent = (props) => {
  return (
    <AnalyticsConfigurationProvider useInitialState={useReactPdpInitialState}>
      <PdpAnalyticsProvider_Implementations>
        {props.children || []}
      </PdpAnalyticsProvider_Implementations>
    </AnalyticsConfigurationProvider>
  );
};
